<template>
  <div class="text-center max-w-xl">
    <h1 class="text-4xl text-gray-900 mb-4">
      Payment Successful! 🎉
    </h1>

    <p v-if="isGuest" class="text-gray-600 mb-10">
      Please check your email
      <span v-if="email" class="font-semibold"> {{ email }} </span>
      to complete registration and get full access
    </p>

    <p v-else class="text-gray-600">
      Redirecting to your tuition details...
    </p>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  isGuest?: boolean
  email?: string | null
}>(), {
  isGuest: false,
  email: null
})
</script>
